// App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// Components
import Header from './Components/Header/header';
import Footer from './Components/footer/footer';


// Pages
import Home from './Pages/home';
import About from './Pages/about'; 
import EnrollmentForm from './Pages/EnrollSection';
import Faq from './Pages/faq';
import BlogList from './Pages/BlogList';
import BlogPostDetail from './Pages/BlogPostDetail';
import ScrollToTop from './Components/ScrollToTop';
import Contact from './Pages/contact';

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      {/* Header appears on all pages */}
      <Header />
       
      {/* Routes decide which page component to show */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/enroll" element={<EnrollmentForm />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="http://blog.tuit.madhiacademy.com/" element={<BlogList />} />
        {/* The Detail Page */}
        <Route path="/blog/indian-vs-global-certifications" element={<BlogPostDetail />} />
         <Route path="/contact" element={<Contact/>} />
      </Routes>

      {/* Footer appears on all pages */}
      <Footer />
    </BrowserRouter>
  );
}

export default App;